import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createElementBlock as _createElementBlock, unref as _unref, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "auth-card" }
const _hoisted_2 = { class: "auth-card__header" }
const _hoisted_3 = { class: "auth-card__logo" }
const _hoisted_4 = { class: "auth-card__subtitle" }
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = { class: "input-group" }
const _hoisted_7 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "mb-3" }
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_14 = { class: "mb-3" }
const _hoisted_15 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "text-center mt-3 mb-0 auth-switch" }

import { ref, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useAuth } from "@/composables/useAuth";
import ErrorMessage from "@/components/common/ErrorMessage.vue";
import AuthPageLayout from "@/components/auth/AuthPageLayout.vue";
import BrandLogo from "@/components/BrandLogo.vue";
import { followAuthRedirect } from "@/utils/authSession";


export default /*@__PURE__*/_defineComponent({
  __name: 'SignUp',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const { sendOtp, verifyOtp, register, loading, error } = useAuth();

const step = ref(1);
const mobile = ref("");
const otpCode = ref("");
const fullName = ref("");
const password = ref("");
const confirmPassword = ref("");
const verificationToken = ref("");
const mobileError = ref("");
const passwordError = ref("");
const confirmError = ref("");
const errorMessage = ref("");

const MOBILE_PATTERN = /^\+?\d{7,15}$/;

const stepSubtitle = computed(() => {
  if (step.value === 1) return "کد تأیید از طریق پیامک برای شما ارسال می‌شود";
  if (step.value === 2) return `کد ارسال‌شده به ${mobile.value} را وارد کنید`;
  return "رمز عبور برای ورودهای بعدی انتخاب کنید";
});

function normalizeMobile(value) {
  return value.replace(/[\s-]/g, "");
}

async function onSendOtp() {
  errorMessage.value = "";
  mobileError.value = "";
  const normalized = normalizeMobile(mobile.value);
  if (!normalized || !MOBILE_PATTERN.test(normalized)) {
    mobileError.value = "شماره موبایل معتبر وارد کنید.";
    return;
  }
  mobile.value = normalized;
  const ok = await sendOtp(normalized, "signup");
  if (ok) step.value = 2;
  else errorMessage.value = error.value || "ارسال کد تأیید انجام نشد.";
}

async function onVerifyOtp() {
  errorMessage.value = "";
  if (!otpCode.value || otpCode.value.length < 4) {
    errorMessage.value = "کد تأیید پیامک را وارد کنید.";
    return;
  }
  const token = await verifyOtp(mobile.value, otpCode.value, "signup");
  if (!token) {
    errorMessage.value = error.value || "کد تأیید نامعتبر است.";
    return;
  }
  verificationToken.value = token;
  step.value = 3;
}

async function onRegister() {
  errorMessage.value = "";
  passwordError.value = "";
  confirmError.value = "";
  if (password.value.length < 8) {
    passwordError.value = "رمز عبور باید حداقل ۸ کاراکتر باشد.";
    return;
  }
  if (password.value !== confirmPassword.value) {
    confirmError.value = "رمز عبور و تکرار آن یکسان نیست.";
    return;
  }
  const ok = await register({
    phone_number: mobile.value,
    password: password.value,
    full_name: fullName.value || null,
    verification_token: verificationToken.value,
  });
  if (ok) {
    const redirect =
      typeof route.query.redirect === "string" ? route.query.redirect : "/dashboard";
    followAuthRedirect(redirect, "/dashboard", (path) => {
      router.push(path);
    });
  } else {
    errorMessage.value = error.value || "ایجاد حساب انجام نشد.";
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(AuthPageLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(BrandLogo, { size: "md" })
          ]),
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "auth-card__icon" }, [
            _createElementVNode("i", { class: "bi bi-person-plus" })
          ], -1)),
          _cache[7] || (_cache[7] = _createElementVNode("h1", { class: "auth-card__title" }, "ایجاد حساب", -1)),
          _createElementVNode("p", _hoisted_4, _toDisplayString(stepSubtitle.value), 1)
        ]),
        (errorMessage.value)
          ? (_openBlock(), _createBlock(ErrorMessage, {
              key: 0,
              title: "ادامه ممکن نشد",
              message: errorMessage.value,
              retryable: false,
              class: "mb-3"
            }, null, 8, ["message"]))
          : _createCommentVNode("", true),
        (step.value === 1)
          ? (_openBlock(), _createElementBlock("form", {
              key: 1,
              onSubmit: _withModifiers(onSendOtp, ["prevent"]),
              novalidate: ""
            }, [
              _createElementVNode("div", _hoisted_5, [
                _cache[9] || (_cache[9] = _createElementVNode("label", {
                  for: "mobile",
                  class: "form-label"
                }, "شماره موبایل", -1)),
                _createElementVNode("div", _hoisted_6, [
                  _cache[8] || (_cache[8] = _createElementVNode("span", { class: "input-group-text" }, [
                    _createElementVNode("i", { class: "bi bi-telephone" })
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "mobile",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((mobile).value = $event)),
                    type: "tel",
                    inputmode: "tel",
                    autocomplete: "tel",
                    class: _normalizeClass(["form-control", { 'is-invalid': mobileError.value }]),
                    placeholder: "مثال: 09123456789"
                  }, null, 2), [
                    [
                      _vModelText,
                      mobile.value,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                (mobileError.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(mobileError.value), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("button", {
                type: "submit",
                class: "btn auth-btn w-100",
                disabled: _unref(loading)
              }, _toDisplayString(_unref(loading) ? "در حال ارسال کد..." : "ارسال کد تأیید"), 9, _hoisted_8)
            ], 32))
          : (step.value === 2)
            ? (_openBlock(), _createElementBlock("form", {
                key: 2,
                onSubmit: _withModifiers(onVerifyOtp, ["prevent"]),
                novalidate: ""
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _cache[10] || (_cache[10] = _createElementVNode("label", {
                    for: "otp",
                    class: "form-label"
                  }, "کد تأیید", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "otp",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((otpCode).value = $event)),
                    type: "text",
                    inputmode: "numeric",
                    maxlength: "6",
                    class: "form-control text-center otp-input",
                    placeholder: "کد ۶ رقمی"
                  }, null, 512), [
                    [
                      _vModelText,
                      otpCode.value,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn auth-btn w-100 mb-2",
                  disabled: _unref(loading)
                }, _toDisplayString(_unref(loading) ? "در حال تأیید..." : "تأیید کد"), 9, _hoisted_10),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-link w-100",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (step.value = 1))
                }, " تغییر شماره موبایل ")
              ], 32))
            : (_openBlock(), _createElementBlock("form", {
                key: 3,
                onSubmit: _withModifiers(onRegister, ["prevent"]),
                novalidate: ""
              }, [
                _createElementVNode("div", _hoisted_11, [
                  _cache[11] || (_cache[11] = _createElementVNode("label", {
                    for: "fullName",
                    class: "form-label"
                  }, "نام کامل (اختیاری)", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "fullName",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((fullName).value = $event)),
                    type: "text",
                    autocomplete: "name",
                    class: "form-control",
                    placeholder: "نام شما"
                  }, null, 512), [
                    [
                      _vModelText,
                      fullName.value,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _cache[12] || (_cache[12] = _createElementVNode("label", {
                    for: "password",
                    class: "form-label"
                  }, "رمز عبور", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "password",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((password).value = $event)),
                    type: "password",
                    autocomplete: "new-password",
                    class: _normalizeClass(["form-control", { 'is-invalid': passwordError.value }]),
                    placeholder: "حداقل ۸ کاراکتر"
                  }, null, 2), [
                    [_vModelText, password.value]
                  ]),
                  (passwordError.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(passwordError.value), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _cache[13] || (_cache[13] = _createElementVNode("label", {
                    for: "confirmPassword",
                    class: "form-label"
                  }, "تکرار رمز عبور", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "confirmPassword",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((confirmPassword).value = $event)),
                    type: "password",
                    autocomplete: "new-password",
                    class: _normalizeClass(["form-control", { 'is-invalid': confirmError.value }])
                  }, null, 2), [
                    [_vModelText, confirmPassword.value]
                  ]),
                  (confirmError.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(confirmError.value), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn auth-btn w-100",
                  disabled: _unref(loading)
                }, _toDisplayString(_unref(loading) ? "در حال ایجاد حساب..." : "ایجاد حساب"), 9, _hoisted_16)
              ], 32)),
        _createElementVNode("p", _hoisted_17, [
          _cache[15] || (_cache[15] = _createTextVNode(" قبلاً ثبت‌نام کرده‌اید؟ ", -1)),
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
              _createTextVNode("ورود", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}
}

})